export default __webpack_public_path__ + "static/media/capsule-locked-small.0bda47de.png";